module.exports = __webpack_public_path__ + "static/img/qq_1.205a4e98.png";